export default {
  title: 'Filtry wyszukiwarki',
  type: 'object',
  properties: {
    date: {
      title: 'Zakres dat',
      type: 'object',
      properties: {
        start: {
          title: 'Minimalna data zakupu',
          type: 'string',
          format: 'date',
          validFunc: '($value && $root.date.end) ? $value <= $root.date.end : true',
          validationMessages: {
            validFunc: 'Minimalna data zakupu musi być wcześniejsza, niż maksymalna'
          }
        },
        end: {
          title: 'Maksymalna data zakupu',
          type: 'string',
          format: 'date',
          validFunc: '($root.date.start && $value) ? $value >= $root.date.start : true',
          validationMessages: {
            validFunc: 'Maksymalna data zakupu musi być późniejsza, niż minimalna'
          }
        }
      }
    },
    search: {
      title: 'Wyszukiwana fraza',
      type: 'string'
    },
    userId: {
      title: 'Pracownik',
      type: 'number'
    },
    logicalStructureId: {
      title: 'Struktura',
      type: 'number'
    },
    tags: {
      title: 'Tagi',
      type: 'array',
      items: {
        type: 'string'
      },
      default: []
    }
  }
};
